import { render, staticRenderFns } from "./TechnicalWorksLayout.vue?vue&type=template&id=b57c0bf6&scoped=true&"
import script from "./TechnicalWorksLayout.vue?vue&type=script&lang=js&"
export * from "./TechnicalWorksLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57c0bf6",
  null
  
)

export default component.exports